import styled from 'styled-components'
import { Border, Colors, Dimensions, Spacing } from '../../styles'
import { DEFAULT_VIEW_WIDTH, pointerQuery } from '../../styles/dimensions'

// The list half of the mobile single-pane swap, tagged to match `data-mobile-pane='detail'` on
// DetailsViewTemplate. DefaultTemplate hides whichever pane the route is not on, so the acceptance
// spec needs a handle on both to tell "showing the list" from "showing the detail".
const ScrollableListTemplate = styled.div.attrs({ 'data-mobile-pane': 'list' })`
    padding: ${Spacing._24} ${Spacing._16} 100px;
    overflow-y: auto;
    width: ${DEFAULT_VIEW_WIDTH};
    background-color: ${Colors.background.white};
    border-right: 1px solid ${Colors.background.border};
    box-sizing: border-box;
    color: ${Colors.text.ink};

    > * {
        border-radius: ${Border.radius.medium};
    }

    ${Dimensions.mediaQuery.phone} {
        width: 100%;
        min-width: 0;
        /* The 96px tail already clears the home indicator, so the bottom gutter only has to grow on
           a phone whose inset is deeper than that. The sides do have to grow: in landscape the
           rounded corners eat a 12px gutter whole. */
        padding: ${Spacing._16} ${Dimensions.safeGutter(Spacing._12, 'right')}
            ${Dimensions.safeGutter('96px', 'bottom')} ${Dimensions.safeGutter(Spacing._12, 'left')};
        border-right: 0;
        /* Keep the pane's rubber-band to the pane. Without this, overscrolling a list bounces the
           whole document behind it, which reads as the app coming unstuck from the screen. */
        overscroll-behavior-y: contain;

        /* Phone browsers use an overlay scroll indicator. Match that geometry in desktop browsers
           emulating touch so a newly scrollable pane does not narrow every full-width card. */
        ${pointerQuery.noHover} {
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
`

export default ScrollableListTemplate
